import { render, staticRenderFns } from "./InlineGoalCard.vue?vue&type=template&id=1fa5c76e&"
import script from "./InlineGoalCard.vue?vue&type=script&lang=js&"
export * from "./InlineGoalCard.vue?vue&type=script&lang=js&"
import style0 from "./InlineGoalCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports